/* eslint-disable prettier/prettier */
import CybsCard from '@cybs-ui/components/lib/card';
import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import './consoleLogComponent.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import ReactJson from 'react-json-view';
import { toggleConsoleCard } from '../../redux/action/3ds-actions';

function ConsoleLogComponent() {
  const dispatch = useDispatch();
  const logStates = useSelector((state) => state.logReducer.logStages);
  const title = 'Console Log';
  useEffect(() => {}, [logStates]);
  return (
    <CybsCard
      dataTest="consoleLog-card"
      className="console-log__card"
      i18n={{ariaLabel: 'This shows request and response payload for the steps performed'}}
      header={<CybsActionBar dataTest="console-log-cardview" i18n={{ title: title }} />}
    >
      {Object.entries(logStates).map((logState) => {
        const cardLabel = `Step ${logState[1].stage}. ${logState[1].name}`;
        if (logState[1].display === false) {
          return '';
        }
        const requesLogTitle = logState[1].request.title;
        const requestLogValue = JSON.stringify(logState[1].request.value, undefined, 4);
        const responseLogTitle = logState[1].response.title;
        const responseLogValue = JSON.stringify(logState[1].response.value, undefined, 4);
        const responseDecodedTitle = logState[1].decodedResponse.title;
        const responseDecodedValue = JSON.stringify(
          logState[1].decodedResponse.value,
          undefined,
          4
        );
        return (
          <div className="row console-log__card__row" key={logState[1].stage}>
            <div className="col-lg12">
              <CybsCard
                dataTest="consoleLog-card__child"
                className="console-log__card__child"
                header={
                  <CybsActionBar
                    dataTest="console-log-cardview__child"
                    i18n={{ title: cardLabel }}
                    collapsible={{
                      isOpen: !logState[1].isCollapsed,
                      onClick: () => {
                        dispatch(toggleConsoleCard(logState[1].stage));
                      }
                    }}
                    numberOfActionsToShow={2}
                    rightActions={[
                      {
                        colorScheme: 'tertiary',
                        dataTest: 'collapsible-icon-1',
                        i18n: { ariaLabel: `copy step ${logState[1].stage}. ${logState[1].name}` },
                        iconClass: 'copy',
                        resolution: 'high',
                        onClick: () => {
                          const textToCopy = [requesLogTitle, '\n', JSON.stringify(logState[1].request.value), '\n', responseLogTitle, '\n', JSON.stringify(logState[1].response.value), '\n', responseDecodedTitle!=undefined?responseDecodedTitle:null, logState[1].decodedResponse.value!=''?JSON.stringify(logState[1].decodedResponse.value):null].join('');
                          navigator.clipboard.writeText(textToCopy);
                        },
                        variant: 'icon'
                      }
                    ]}
                  />
                }
                isCollapsed={logState[1].isCollapsed}
              >
                {requesLogTitle === undefined ||
                requestLogValue === undefined ||
                requesLogTitle.length === 0 ||
                requestLogValue.length === 0 ? (
                    ''
                  ) : (
                    <div className="row">
                      <div className="row consoleLog_request-title">{requesLogTitle}</div>
                      {typeof(logState[1].request.value) === 'object' 
                        ? <ReactJson src={logState[1].request.value} displayDataTypes={false} name={false} displayObjectSize={false} enableClipboard={false}/> 
                        : <p>{logState[1].request.value}</p>}
                    </div>
                  )}
                {responseLogTitle === undefined ||
                responseLogValue === undefined ||
                responseLogTitle.length === 0 ||
                responseLogValue.length === 0 ? (
                    ''
                  ) : (
                    <>
                      <hr className="consoleLog_divider" />
                      <div className="row">
                        <div className="row consoleLog_response-title">{responseLogTitle}</div>
                        {typeof(logState[1].response.value) === 'object' 
                          ? <ReactJson src={logState[1].response.value} displayDataTypes={false} name={false} displayObjectSize={false} enableClipboard={false}/> 
                          : <p>{logState[1].response.value}</p>}
                      </div>
                    </>
                  )}
                {responseDecodedTitle === undefined ||
                responseDecodedValue === undefined ||
                responseDecodedTitle.length === 0 ||
                responseDecodedValue.length === 0 ? (
                    ''
                  ) : (
                    <>
                      <hr className="consoleLog_divider" />
                      <div className="row">
                        <div className="row consoleLog_response-title">{responseDecodedTitle}</div>
                        {typeof(logState[1].decodedResponse.value) === 'object' 
                          ? <ReactJson src={logState[1].decodedResponse.value} displayDataTypes={false} name={false} displayObjectSize={false} enableClipboard={false}/> 
                          : <p>{logState[1].decodedResponse.value}</p>}
                      </div>
                    </>
                  )}
              </CybsCard>
            </div>
          </div>
        );
      })}
    </CybsCard>
  );
}

export default ConsoleLogComponent;
